export default __webpack_public_path__ + "static/media/ran.47b3c5f8.png";